import React from 'react';
import { AnimatePresence as FramerAnimatePresence, AnimatePresenceProps } from 'framer-motion';

// Wrapper to fix React 19 TypeScript compatibility issue
export const AnimatePresence: React.FC<React.PropsWithChildren<AnimatePresenceProps>> = ({ children, ...props }) => {
  // Type assertion to fix React 19 compatibility
  const Component = FramerAnimatePresence as any;
  return <Component {...props}>{children}</Component>;
};